import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

export default function Testimonials({ content }) {
  const items = content.testimonials || [];
  return (
    <section id="reviews" className="relative py-24 sm:py-32 bg-navy/40" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }} className="font-mono text-xs tracking-[0.25em] uppercase text-sky mb-4">
          Homeowner Reviews
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
          Trusted in homes across Dallas.
        </motion.h2>

        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <motion.figure key={t.name + i}
              initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="relative rounded-3xl border border-white/10 bg-card/60 p-8 hover:border-sky/40 transition-colors duration-300"
              data-testid={`testimonial-${i}`}>
              <Quote className="h-7 w-7 text-royal mb-5" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-sky text-sky" />
                ))}
              </div>
              <blockquote className="text-slate-300 leading-relaxed text-sm sm:text-base">{t.text}</blockquote>
              <figcaption className="mt-6 pt-5 border-t border-white/10">
                <p className="font-display font-bold">{t.name}</p>
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-slate-500 mt-1">{t.location}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
